export const selectMeasurementTypes = (state) => {
    return state.measurementTypes;
}

export const selectMeasurementType = (state) => {
    return state.measurementTypes.current;
}
